module.exports = __webpack_public_path__ + "media/images/covid/traveling_safely_zh-hant-2d6e58df4893d40d93224aee61bc0e4e.jpg";